import React, { useState } from 'react'
import MenuIcon from '@material-ui/icons/Menu'
import './Header.css'
import LogoD from './images/LogoD.jpg'
import Sidebar from './Sidebar'
import { Link } from 'react-router-dom'
import { Flip, Zoom } from 'react-reveal'

function Header() {
    const [sidebar, setSidebar] = useState(false)

    const showSidebar = () => setSidebar(!sidebar)

    return (
        <div className='header'>
            <Link to='/'>
                <Zoom right className='header__zoomEffect'>
                    <img
                        className='header__logo'
                        src={LogoD}
                        alt=''
                    />
                </Zoom>
           </Link>

            {/* <div className="header__middle">
                <input
                    type='text'
                    placeholder='Search here...'
                />
                <p >
                    <SearchIcon className='header__searchIcon' />
                </p>
            </div> */}
            <div className="header__right">
                <Flip left>
                <p className='header__rightDonate'>Donate</p>
                </Flip>
                <MenuIcon
                onClick={showSidebar}
                className='header__rightIcon' />
                
                <div onClick={showSidebar} className={sidebar ? "header__rightSidebarActive": "header__rightSidebar"}>
                    <Sidebar />
                </div>
            </div>
        </div>
    )
}

export default Header
